"use client";

import { usePathname } from "next/navigation";
import { useLocale } from "next-intl";
import React from "react";
import { Link } from "../../../i18n/navigation";
import { useTransitionRouter } from "next-view-transitions";

type LocalizedLinkProps = {
    slug: string;
    id?: string;
    label: string | React.ReactNode;
    className?: string;
    scroll?: boolean;
    exact?: boolean;
    onClickHandler?: () => void;
};

export const LocalizedLink = ({
    slug,
    label,
    id,
    className,
    scroll = true,
    onClickHandler,
}: LocalizedLinkProps) => {
    const router = useTransitionRouter();
    const locale = useLocale();
    const pathname = usePathname();

    const isDefaultLocale = locale === "de";
    const href = `/${slug}`;
    const localizedHref = isDefaultLocale ? href : `/${locale}${href}`;

    const currentPath = pathname.replace(/^\/(de|en)/, "").replace(/^\//, "");

    const isActive = currentPath === slug;

    function slideInOut() {
        document.documentElement.animate(
            [
                {
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
                    // clipPath: "polygon(25% 75%, 75% 75%, 75% 75%, 25% 75%)",
                },
                {
                    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                },
            ],
            {
                duration: 1000,
                easing: "cubic-bezier(0.9, 0, 0.1, 1)",
                pseudoElement: "::view-transition-new(root)",
            },
        );
    }

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (isActive) {
            e.preventDefault();
            return;
        }

        e.preventDefault();

        router.push(localizedHref, {
            scroll: true,
            onTransitionReady: slideInOut,
        });

        onClickHandler && onClickHandler();
    };

    return (
        <Link
            href={href}
            {...(id && { id })}
            {...(!isDefaultLocale && { locale })}
            className={className}
            onClick={handleClick}
        >
            {label}
        </Link>
    );
};
